import { getFirstBrowserLanguage } from '../helpers';

export const defaultLocale = getFirstBrowserLanguage();

export const locales = [
  {
    code: 'en',
    name: 'Anglais'
  },
  {
    code: 'fr',
    name: 'Français'
  },
  {
    code: 'de',
    name: 'Allemand'
  }
];
